import { ReceiptModel } from '~app/shopping-cart/receipt/state/receipt.model';
import { FormStatus } from '../../../../shared/model/company.model';
import { IAttestationAndAuthorization } from './attestation-and-authorization.model';
import { AttachedDocuments, CompanyAmalgamation, CompanyIdentification, CompanyNonVotingNaturalPersons, CompanyOtherEstablishment, CompanyOtherName, CompanyRepresentativeSubstitute, LegalPerson, ShareHolderMember } from './company-identification.model';
import { MandatedIdentification } from './mandatedIdentification.model';

export class AnnualDeclaration {
  identification: CompanyIdentification;
  otherNames: { otherNames: CompanyOtherName[] };
  representativeSubstitute: CompanyRepresentativeSubstitute;
  otherEstablishments: { otherEstablishments: CompanyOtherEstablishment[] };
  directors: { directorsNumber: number };
  votingMembers: { votingMembers: ShareHolderMember[] };
  votingLegalPersons: { legalPersons: LegalPerson[] };
  nonVotingNaturalPersons: CompanyNonVotingNaturalPersons;
  nonVotingLegalPersons: { legalPersons: LegalPerson[] };
  annualDeclaractionFormAttachment: AttachedDocuments[];
  amalgamation: CompanyAmalgamation;

  // Todo : On fait quoi de l'atestation ?
  attestationAndAuthorization: IAttestationAndAuthorization;

  constructor() {
    this.identification = null;
    this.otherNames = { otherNames: null };
    this.representativeSubstitute = null;
    this.otherEstablishments = { otherEstablishments: null };
    this.directors = { directorsNumber: null };
    this.votingMembers = { votingMembers: null };
    this.votingLegalPersons = { legalPersons: null };
    this.nonVotingNaturalPersons = null;
    this.nonVotingLegalPersons = { legalPersons: null };
    this.amalgamation = null;
  }

}

export enum AnnualDeclarationFormGroupEnum {
  CompanyIdentification = 'companyIdentification',
  CompanyOtherNames = 'companyOtherNames',
  CompanyRepresentativeSubstitute = 'companyRepresentativeSubstitute',
  CompanyOtherEstablishments = 'companyOtherEstablishments',
  CompanyDirectors = 'companyDirectors',
  CompanyVotingMembers = 'companyVotingMembers',
  CompanyVotingLegalPersons = 'companyVotingLegalPersons',
  CompanyNonVotingNaturalPersons = 'companyNonVotingNaturalPersons',
  CompanyNonVotingLegalPersons = 'companyNonVotingLegalPersons',
  CompanyAmalgamation = 'companyAmalgamation',
}

export class AnnualDeclarationFormCollection {
  lastSavedDate: string;
  current: AnnualDeclaration;
  original: AnnualDeclaration;
  legalEntityNumber: string;
  formId: string;
  state: FormStatus;
  summaryAttachment: AttachedDocuments;
  attachedDocuments: AttachedDocuments[];
  // transient date, used for display and pdf requests
  mandatedIdentification: MandatedIdentification;
  // transient property for graphical purposes
  isSummaryDownloading: boolean;
  paymentConfirmation: ReceiptModel;
}
